(function () {

  const VIDEO_SELECTOR =
    '.tab-content#videos .rte iframe[src*="youtube.com"], ' +
    '.tab-content#videos .rte iframe[src*="youtube-nocookie.com"], ' +
    '.tab-content#videos .rte iframe[src*="youtu.be"]';


  /*
    PORTADAS MANUALES

    Aquí puedes poner una portada personalizada para cualquier vídeo.

    Ejemplo:

    "ABC123xyz": "https://cdn.shopify.com/s/files/.../portada.jpg"

    ABC123xyz = ID del vídeo de YouTube.
  */

  const VIDEO_POSTERS = {

    // "ID_VIDEO": "URL_IMAGEN"

  };


  function getYoutubeId(url) {

    if (!url) return null;


    try {

      const normalizedUrl =
        url.startsWith("//")
          ? window.location.protocol + url
          : url;


      const parsed =
        new URL(
          normalizedUrl,
          window.location.origin
        );


      const host =
        parsed.hostname.toLowerCase();


      if (host.includes("youtu.be")) {

        return (
          parsed.pathname
            .replace(/^\//, "")
            .split("/")[0] || null
        );

      }


      if (
        host.includes("youtube.com") ||
        host.includes("youtube-nocookie.com")
      ) {

        const embedMatch =
          parsed.pathname.match(
            /\/embed\/([^/?]+)/
          );


        if (
          embedMatch &&
          embedMatch[1]
        ) {

          return embedMatch[1];

        }


        const shortsMatch =
          parsed.pathname.match(
            /\/shorts\/([^/?]+)/
          );


        if (
          shortsMatch &&
          shortsMatch[1]
        ) {

          return shortsMatch[1];

        }


        return parsed.searchParams.get("v");

      }

    } catch (error) {

      const fallbackMatch =
        url.match(
          /youtube\.com\/embed\/([^?&"'/]+)/
        ) ||
        url.match(
          /youtube-nocookie\.com\/embed\/([^?&"'/]+)/
        ) ||
        url.match(
          /youtu\.be\/([^?&"'/]+)/
        ) ||
        url.match(
          /[?&]v=([^?&"'/]+)/
        );


      if (
        fallbackMatch &&
        fallbackMatch[1]
      ) {

        return fallbackMatch[1];

      }

    }


    return null;

  }


  function buildAutoplayUrl(url) {

    try {

      const normalizedUrl =
        url.startsWith("//")
          ? window.location.protocol + url
          : url;


      const parsed =
        new URL(
          normalizedUrl,
          window.location.origin
        );


      parsed.searchParams.set(
        "autoplay",
        "1"
      );


      parsed.searchParams.set(
        "rel",
        "0"
      );


      parsed.searchParams.set(
        "playsinline",
        "1"
      );


      return parsed.toString();

    } catch (error) {

      const separator =
        url.includes("?")
          ? "&"
          : "?";


      return (
        url +
        separator +
        "autoplay=1&rel=0&playsinline=1"
      );

    }

  }


  /*
    PORTADA

    1. Si hay una portada manual, usa esa.
    2. Si no, busca automáticamente la mejor
       portada disponible de YouTube.
  */

  function setPoster(
    poster,
    youtubeId
  ) {

    const manualPoster =
      VIDEO_POSTERS[youtubeId];


    if (manualPoster) {

      poster.src =
        manualPoster;

      return;

    }


    const candidates = [

      `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,

      `https://i.ytimg.com/vi/${youtubeId}/sddefault.jpg`,

      `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`

    ];


    let index = 0;


    function tryNext() {

      if (
        index >=
        candidates.length
      ) {

        return;

      }


      const url =
        candidates[index++];


      const test =
        new Image();


      test.onload =
        function () {

          if (
            test.naturalWidth >= 480 &&
            test.naturalHeight >= 270
          ) {

            poster.src =
              url;

          } else {

            tryNext();

          }

        };


      test.onerror =
        tryNext;


      test.src =
        url;

    }


    tryNext();

  }


  function createVideoHeader() {

    const header =
      document.createElement("div");


    header.className =
      "product-video-card__header";


    header.innerHTML = `
      <span
        class="product-video-card__icon"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
        >

          <rect
            x="3"
            y="5"
            width="18"
            height="14"
            rx="2.5"
            stroke="currentColor"
            stroke-width="1.8"
          ></rect>

          <path
            d="M10 9.5L15 12L10 14.5V9.5Z"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linejoin="round"
          ></path>

        </svg>
      </span>

      <span class="product-video-card__heading">

        <span class="product-video-card__eyebrow">
          Vídeo del producto
        </span>

        <span class="product-video-card__title">
          Demostración y funcionamiento
        </span>

      </span>
    `;


    return header;

  }


  function createPreview(
    iframe,
    youtubeId
  ) {

    const src =
      iframe.getAttribute("src") ||
      "";


    const preview =
      document.createElement("div");


    preview.className =
      "product-video-preview";


    preview.dataset.embedSrc =
      src;


    preview.dataset.iframeTitle =
      iframe.getAttribute("title") ||
      "Vídeo de YouTube";


    const button =
      document.createElement("button");


    button.className =
      "product-video-preview__button";


    button.type =
      "button";


    button.setAttribute(
      "aria-label",
      "Reproducir vídeo"
    );


    const poster =
      document.createElement("img");


    poster.className =
      "product-video-preview__poster";


    poster.loading =
      "lazy";


    poster.decoding =
      "async";


    poster.alt =
      "Vista previa del vídeo";


    setPoster(
      poster,
      youtubeId
    );


    const play =
      document.createElement("span");


    play.className =
      "product-video-preview__play";


    play.setAttribute(
      "aria-hidden",
      "true"
    );


    button.appendChild(
      poster
    );


    button.appendChild(
      play
    );


    preview.appendChild(
      button
    );


    return preview;

  }


  function enhanceYoutubeIframe(
    iframe
  ) {

    if (
      !iframe ||
      iframe.dataset.previewEnhanced === "true"
    ) {

      return;

    }


    if (
      iframe.closest(
        ".product-video-preview"
      )
    ) {

      return;

    }


    const src =
      iframe.getAttribute("src") ||
      "";


    const youtubeId =
      getYoutubeId(src);


    if (!youtubeId) {

      return;

    }


    iframe.dataset.previewEnhanced =
      "true";


    const card =
      document.createElement("div");


    card.className =
      "product-video-card";


    card.appendChild(
      createVideoHeader()
    );


    card.appendChild(
      createPreview(
        iframe,
        youtubeId
      )
    );


    /*
      Shopify suele meter los vídeos
      dentro de .video-wrapper.
    */

    const videoWrapper =
      iframe.closest(
        ".video-wrapper"
      );


    if (
      videoWrapper &&
      videoWrapper.closest("#videos")
    ) {

      const wrapperParent =
        videoWrapper.parentElement;


      if (
        wrapperParent &&
        wrapperParent.tagName === "P" &&
        wrapperParent.children.length === 1
      ) {

        wrapperParent.replaceWith(
          card
        );

      } else {

        videoWrapper.replaceWith(
          card
        );

      }


      return;

    }


    /*
      Si Shopify ha dejado el iframe
      solo dentro de un párrafo.
    */

    const parent =
      iframe.parentElement;


    if (
      parent &&
      parent.tagName === "P" &&
      parent.children.length === 1
    ) {

      parent.replaceWith(
        card
      );


      return;

    }


    iframe.replaceWith(
      card
    );

  }


  function initVideoPreviews(
    root
  ) {

    const scope =
      root || document;


    if (
      scope instanceof Element &&
      scope.matches(VIDEO_SELECTOR)
    ) {

      enhanceYoutubeIframe(
        scope
      );

    }


    if (
      scope.querySelectorAll
    ) {

      scope
        .querySelectorAll(
          VIDEO_SELECTOR
        )
        .forEach(
          enhanceYoutubeIframe
        );

    }

  }


  function replaceWithIframe(
    preview
  ) {

    const src =
      preview.dataset.embedSrc;


    if (!src) {

      return;

    }


    const iframe =
      document.createElement(
        "iframe"
      );


    iframe.src =
      buildAutoplayUrl(
        src
      );


    iframe.title =
      preview.dataset.iframeTitle ||
      "Vídeo de YouTube";


    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";


    iframe.allowFullscreen =
      true;


    iframe.loading =
      "lazy";


    iframe.referrerPolicy =
      "strict-origin-when-cross-origin";


    /*
      Impide que el MutationObserver
      vuelva a transformar este iframe.
    */

    iframe.dataset.previewEnhanced =
      "true";


    preview.replaceChildren(
      iframe
    );

  }


  document.addEventListener(
    "click",
    function (event) {

      const button =
        event.target.closest(
          ".product-video-preview__button"
        );


      if (!button) {

        return;

      }


      const preview =
        button.closest(
          ".product-video-preview"
        );


      if (!preview) {

        return;

      }


      replaceWithIframe(
        preview
      );

    }
  );


  function start() {

    initVideoPreviews(
      document
    );


    const observer =
      new MutationObserver(
        function (mutations) {

          mutations.forEach(
            function (mutation) {

              mutation.addedNodes.forEach(
                function (node) {

                  if (
                    !(node instanceof HTMLElement)
                  ) {

                    return;

                  }


                  initVideoPreviews(
                    node
                  );

                }
              );

            }
          );

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      start
    );

  } else {

    start();

  }

})();